export default class HotelImportModel {
    public static Create(obj?: Partial<HotelImportModel>) {
        return Object.assign(new HotelImportModel(), obj ?? {}, {
            errors: (obj?.errors ?? []).slice(),
        })
    }

    rowNumber: number = 0
    name: string = ''
    nameUrl: string = ''
    countryName: string = ''
    countryId: number = 0
    cityId?: number = undefined
    cityName: string = ''
    regionId?: number = undefined
    regionName: string = ''
    isDuplicate: boolean = false
    canAddCity: boolean = false
    canAddRegion: boolean = false
    addCityOnImport: boolean = false
    addRegionOnImport: boolean = false
    isLocked: boolean = false
    matchedByName: boolean = false
    hasError: boolean = false
    errors: string[] = []
    isDeleted: boolean = false
    isSaved: boolean = false
    saveError: string = ''
    address: string = ''
    phone: string = ''
    email: string = ''
    latitude?: number = undefined
    longitude?: number = undefined
}
